var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartFavoritesOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4149 94.78H57.5849L27.7574 54.33C23.4874 48.54 22.8074 40.8925 25.9799 34.37C29.0374 28.085 34.9324 24.21 41.7474 24.0075C41.9499 24.0025 42.1524 23.9975 42.3574 23.9975C49.4849 23.9975 55.3374 27.66 59.2774 34.59C59.5349 35.0425 59.7749 35.4925 59.9999 35.9425C60.2249 35.495 60.4649 35.0425 60.7224 34.59C64.6624 27.66 70.5124 23.9975 77.6424 23.9975C77.8475 23.9975 78.0499 24 78.2524 24.0075C85.0674 24.21 90.9624 28.085 94.0199 34.37C97.1924 40.89 96.5099 48.54 92.2424 54.33L62.4149 94.78ZM42.3574 30C42.2124 30 42.0699 30 41.9274 30.0075C37.3849 30.1425 33.4399 32.7575 31.3749 36.9975C29.1824 41.505 29.6474 46.7825 32.5874 50.77L59.9999 87.945L87.4124 50.77C90.3524 46.7825 90.8174 41.505 88.6249 36.9975C86.5599 32.755 82.6174 30.1425 78.0724 30.0075C77.9299 30.0025 77.785 30 77.6424 30C72.7724 30 68.8599 32.4975 66.0149 37.425C63.6924 41.4475 62.9674 45.6025 62.9599 45.645L57.0799 45.6375L57.0424 45.645C57.0349 45.6025 56.3099 41.4475 53.9874 37.425C51.1424 32.4975 47.2299 30 42.3599 30H42.3574Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFavoritesOutline);
export default __webpack_public_path__ + "static/media/HeartFavorites_Outline.7b6ca129.svg";
export { ForwardRef as ReactComponent };